export var DEFAULT_HOTEL_SORT = "maxDiscountAvailable";
export var HotelSortOptions = [
    {
        id: "recommended",
        displayName: "Recommended",
    },
    {
        id: "price|asc",
        displayName: "Price - Low to High",
    },
    {
        id: "price|desc",
        displayName: "Price - High to Low",
    },
    {
        id: "star_rating|desc",
        displayName: "Star Rating",
    },
    {
        id: "review_rating|desc",
        displayName: "Guest Score",
    },
    {
        id: "name",
        displayName: "Hotel Name",
    },
    {
        id: "discount",
        displayName: "Discount",
    },
    {
        id: "maxDiscountAvailable",
        displayName: "Discount",
    },
];
//@TODO: Cleanup...
export var HotelSortOptionsMap = {
    recommended: "Recommended",
    name: "Hotel Name",
    "price|desc": "Price - High to Low",
    "price|asc": "Price - Low to High",
    "star_rating|desc": "Star Rating",
    "review_rating|desc": "Guest Rating",
    discount: "Discount",
    maxDiscountAvailable: "Discount",
};
export var HotelRateSortOptions = [
    {
        id: "price:asc",
        displayName: "Price - Low to High",
    },
    {
        id: "price:desc",
        displayName: "Price - High to Low",
    },
];
export var HotelTopAmenities = [
    "5", // free wifi
    "1556", // free wifi
    "510", // free wifi
    "7", // free breakfast
    "10", // free parking
    "13", // pets allowed
    "15", // swimming pool
    "", // airport shuttle
    "6081", // spa
    "818", // restaurant
    "3", // casino
    "1530", // non smoking rooms/facilities
    "162", // accessible rooms/facilities
    "5731", // fitness center
    "2", // business center
    "", // all inclusive
    "", // adults only
    "5791", // hot tub/whirlpool
];
export var HotelRoomRateTopAmenities = ["FREE WIFI", "FRIDGE"];
export var HotelRoomTopAmenities = HotelRoomRateTopAmenities;
export var HotelTopBookReasons = [
    "payLater",
    "kidsFree",
    "guestsLove",
    "veryClean",
    "location",
    "refundable",
];
export var HotelSortingWeightParams = [
    "name",
    "price",
    "hasDeal",
    "savingsPercent",
    "starRating",
    "reviewRating",
    "reviewCount",
];
